<template>
  <b-card class="mobile-margin-top all-margin-top">
    <b-card-body class="padding-removed-custom">
      <b-container fluid>
        <b-row class="text-center">
          <b-col><strong>Select</strong> your Vitality Money Status</b-col>
        </b-row>

        <b-row class="d-none d-sm-block mt-5">
          <b-col>
            <div class="item-container">
              <div
                :class="['item-progress', 'color-' + status.text]"
                v-for="(status, index) in statuses"
                :key="index"
                @click="setActive(status)"
              >
                <p v-show="status.text == active" class="external-text smallest-font">
                  {{ active }} status
                </p>

                <img
                  class="vm-token"
                  v-show="status.text == active"
                  :src="
                    require('@/assets/images/vitality-money-' + active + '.svg')
                  "
                  alt=""
                  
                />
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="d-block d-sm-none">
          <b-col>
            <b-form-select v-model="active" @change="setActiveDropDown($event)">
              <option
                v-for="(item, index) in statuses"
                :key="index"
                :value="item.text"
              >
                {{ item.text }}
              </option>
            </b-form-select>
          </b-col>
        </b-row>
      </b-container>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: {
    activeVM: {
      default: "Diamond",
    },
  },

  methods: {
    setActive(item) {
      this.active = item.text;

      this.$emit("active", item.text);
    },
    setActiveDropDown(item) {
      this.active = item;

      this.$emit("active", item);
    },
  },
  watch: {
    // $activeVM(){
    //   this.active=this.activeVM
    // }
  },
  data() {
    return {
      value: "Diamond",
      data: ["Blue", "Bronze", "Silver", "Gold", "Diamond"],

      active: this.activeVM,
      statuses: [
        {
          text: "Blue",
          colour: "5080ba",
        },
        {
          text: "Bronze",
          colour: "d18451",
        },
        {
          text: "Silver",
          colour: "c3c3c4",
        },
        {
          text: "Gold",
          colour: "eacd5f",
        },
        {
          text: "Diamond",
          colour: "c7b2cc",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.color-Blue {
  background: linear-gradient(
    90deg,
    rgba(80, 128, 186, 1) 0%,
    rgb(169, 206, 252) 100%
  );
  z-index: 5;
}
.color-Bronze {
  background: linear-gradient(
    90deg,
    rgba(209, 132, 81, 1) 0%,
    rgb(241, 201, 176) 100%
  );
  z-index: 4;
}
.color-Silver {
  background: linear-gradient(
    90deg,
    rgba(195, 195, 196, 1) 0%,
    rgb(233, 233, 235) 100%
  );
  z-index: 3;
}
.color-Gold {
  background: linear-gradient(
    90deg,
    rgba(234, 205, 95, 1) 0%,
    rgb(250, 231, 162) 100%
  );
  z-index: 2;
}
.color-Diamond {
  background-color: #c7b2cc;
  z-index: 1;
}
.item-progress {
  margin-right: -0.5em;
  height: 1.2em;
  border-top-right-radius: 0.8em;
  border-bottom-right-radius: 0.8em;
  width: 21.5%;
}
.item-container {
  cursor: pointer;
  display: flex;
}
.ball {
  position: relative;
  left: 40%;
  top: -30%;
}
.external-text {
  text-align: center;
  position: absolute;
  top: -2em;
  width: 9rem;
  font-weight: 500;
  font-size: large;
}
.vm-icon {
  position: absolute;
  top: -8px;
  left: -10px;
}
.vm-token{
  
  height: 35px;
}
.vm-icon-small {
  position: absolute;
  top: -4px;
  left: -10px;
}

@media only screen and (min-width: 1200px) {
 
  @media only screen and (max-width: 1590px) {
     .external-text {
    font-size: smaller !important;
  }
  }
}
</style>